export default __webpack_public_path__ + "static/media/illustration-passionate.f7cd8dfd.svg";